<template>
  <div
    :class="{ 'form-multi-select__disabled': disable, 'form-multi-select__active': showSelectList }"
    class="form-multi-select"
    @click="!disable ? onShowSelectList($event) : null"
  >
    <div class="upper-label">{{ label }}</div>
    <label v-if="choosedList.length > 0">{{ getChoosedList() }}</label>
    <label v-if="choosedList.length === 0">Не выбрано</label>
    <div v-if="showSelectList" class="multi-select-content" @click="onClickList($event)">
      <div class="search-list">
        <input v-model="searchList" type="text" @keyup="onSearchList" />
      </div>
      <ul>
        <template v-if="Array.isArray(list) && list.length > 0">
          <li
            v-for="(li, index) in list"
            :key="index"
            :class="{ 'checked-li': choosedList.indexOf(li.value) > -1 }"
            @click="onCheckItem(li)"
          >
            {{ li.text }}
          </li>
        </template>
        <li v-if="list.length === 0">Пусто</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "FormMultiSelect",
  props: {
    restApi: {
      type: [Boolean, String],
      default: false
    },
    fieldname: {
      type: String,
      default: ""
    },
    inputModel: {
      type: Array,
      default: () => []
    },
    choosed: {
      type: Array,
      default: () => []
    },
    value: {
      type: Array,
      default: () => []
    },
    twoLevelUpdate: {
      type: Function,
      default: () => {}
    },
    label: {
      type: String,
      default: ""
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showSelectList: false,
      list: [],
      searchList: "",
      initialList: [],
      choosedList: []
    };
  },
  watch: {
    choosed(newValue) {
      this.choosedList = newValue;
    },
    inputModel(newValue) {
      if (this.restApi) {
        this.getSource({
          url: "/api/waste-area/owner-suggestion/",
          params: {
            name: ""
          }
        }).then(res => {
          const inputModel = res.data.map(s => {
            s.value = s.id;
            s.text = s.full_name;
            return s;
          });
          this.initialList = inputModel;
          this.list = inputModel;
        });
        return;
      }

      this.initialList = this.inputModel;
      this.list = newValue.map(s => {
        if (s.category_name !== undefined) {
          s.text = s.category_name;
          s.value = s.id;
        }
        if (this.choosed.indexOf(s.value) > -1) {
          s.checked = true;
        } else {
          s.checked = false;
        }
        return s;
      });
      this.choosedList = this.choosed;
    }
  },
  mounted() {
    this.initialList = this.inputModel;
    this.list = this.inputModel.map(s => {
      if (s.category_name !== undefined) {
        s.text = s.category_name;
        s.value = s.id;
      }
      if (this.choosed.indexOf(s.value) > -1) {
        s.checked = true;
      } else {
        s.checked = false;
      }
      return s;
    });
    this.choosedList = this.choosed;

    document.body.addEventListener("click", this.onBodyClick);

    this.initialList = JSON.parse(JSON.stringify(this.inputModel));
    this.list = this.initialList.map(s => {
      if (s.category_name !== undefined) {
        s.text = s.category_name;
        s.value = s.id;
      }
      if (this.choosed.indexOf(s.value) > -1) {
        s.checked = true;
      } else {
        s.checked = false;
      }
      return s;
    });
    this.choosedList = JSON.parse(JSON.stringify(this.choosed));
  },
  beforeDestroy() {
    document.body.removeEventListener("click", this.onBodyClick);
  },
  methods: {
    ...mapActions(["getSource"]),
    getChoosedList() {
      const choosed = this.choosedList.map(s => {
        const findedElem = this.initialList.find(l => l.value === s);
        if (findedElem) {
          return findedElem.text;
        }
      });
      if (choosed.length < 3) {
        let choosedText = "";
        choosed.map((s, i) => {
          if (i === choosed.length - 1) {
            choosedText += `${s}`;
          } else {
            choosedText += `${s}, `;
          }
        });
        return choosedText;
      } else {
        return `Выбрано ${choosed.length} объекта`;
      }
    },
    onShowSelectList(e) {
      this.showSelectList = !this.showSelectList;
      e.stopPropagation();
    },
    onClickList(e) {
      e.stopPropagation();
    },
    onCheckItem(li) {
      if (this.choosedList.indexOf(li.value) > -1) {
        this.choosedList = this.choosedList.filter(s => s !== li.value);
      } else {
        this.choosedList.push(li.value);
      }
      this.$emit("update", { value: this.choosedList, fieldname: this.fieldname });
    },
    onBodyClick() {
      this.showSelectList = false;
    },
    onSearchList() {
      this.list = this.initialList.filter(s => s.text.toLowerCase().indexOf(this.searchList.toLowerCase()) > -1);
    }
  }
};
</script>
